import { useNavigate } from "react-router-dom";
import { policies } from "./policies";

const policyRoutes = {
  // ===== GENERAL BUSINESS POLICIES =====
  termsGeneral: "/terms-conditions",
  generalPrivacy: "/privacy-policy",
  cookiePolicy: "/cookie-policy",
  paymentPortalTerms: "/payment-portal-terms",
  fraudulentCommunications: "/fraudulent-communications",
  emailCommunicationPseudonymPolicy: "/email-pseudonym-policy",

  // ===== CONFERENCE POLICIES =====
  conferencePrivacyPolicy: "/conference-privacy-policy",
  conferenceTermsConditions: "/conference-terms-conditions",
  codeOfConduct: "/code-of-conduct",
  mediaPartnership: "/media-partnership-terms",
};

export default function Left({ currentPolicy }) {
  const navigate = useNavigate();

  return (
    <aside className="policy-sidebar">
      {Object.entries(policies.categories).map(([catKey, category]) => (
        <div key={catKey} className="category">
          <h3>{category.title}</h3>
          <ul>
            {Object.entries(category.policies).map(([policyKey, policy]) => {
              const route = policyRoutes[policyKey];
              if (!route) return null; // prevent crashes

              return (
                <li
                  key={policyKey}
                  className={currentPolicy === policyKey ? "active" : ""}
                  onClick={() => navigate(route)}
                >
                  {policy.title}
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </aside>
  );
}
